import { StyledCtaSection, StyledLink } from './CtaSection.styles';

type CtaSectionProps = {
  ctas?: NonNullable<Queries.HEADERFragment['headerElements']['cta_section']>['value'];
};

const CtaSection = ({ ctas }: CtaSectionProps) => (
  <StyledCtaSection>
    {ctas?.map((link, index) => (
      <StyledLink
        {...link}
        key={link.system.id}
        variant={index === 1 ? 'secondary_small' : 'primary_small'}
      />
    ))}
  </StyledCtaSection>
);

export default CtaSection;
